<template>
  <div class="inquiry-num big">
    <div
      class="flex between"
      style="padding-right:20px"
    >
      <div class="page_title">问诊单详情</div>
      <el-button
        type="primary"
        @click="back"
        style="width:120px"
      >返回</el-button>
    </div>

    <div style="padding:20px;">
      <div class="container">
        <!-- 信息 -->
        <info
          :doctorInfo="doctor_info"
          :userInfo="patient_info"
        ></info>

        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >

            <el-table-column
              v-for="(item,index) in tableHeader"
              :key="index"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
              :align="item.align"
            >
            </el-table-column>

            <el-table-column
              label="操作"
              width="220"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="lookInquiry(scope.row)"
                  :disabled="module_id_array[0]? !module_id_array.includes('634'): false"
                >查看</el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>

        <div class="footer-pagination">
          <pagination
            v-show="totalNum>0"
            :total="totalNum"
            :page.sync="pagination.page"
            :limit.sync="pagination.pageNumber"
            @pagination="searchList"
          />
        </div>

      </div>
    </div>
    <!-- 查看 -->
    <inquiry-tem
      v-if="isLook"
      :consult_inquiry_id="consult_inquiry_id"
      @close="isLook = false"
    ></inquiry-tem>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import message from '../../../../api/message';
import Pagination from '@/components/Pagination';
import Info from '../components/Info.vue';
import InquiryTem from '../components/inquiryTem.vue';
export default {
  components: {
    Pagination,
    Info,
    InquiryTem
  },
  data() {
    return {
      isLook: false,
      consult_inquiry_id: '',
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      doctor_info: {},
      patient_info: {},
      tableHeader: [
        {
          label: '最新推送问诊单时间',
          prop: 'create_time',
          width: '200',
          align: 'left'
        },
        {
          label: '问诊单模板名称',
          prop: 'inquiry_sheet_name',
          width: 'auto',
          align: 'left'
        }
      ],
      tableData: []
    };
  },
  filters: {},
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routerData() {
      return this.$route.query;
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.tableLoading = true;
      console.log(this.routerData);
      message.getInquiryPatientDetail(this.routerData).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.patient_info = data.patient_info ? data.patient_info : {};
          this.doctor_info = data.doctor_info ? data.doctor_info : {};
          this.tableData = data.list;
          this.tableLoading = false;
        }
      });
    },
    lookInquiry(row) {
      this.consult_inquiry_id = row.consult_inquiry_id;
      this.isLook = true;
    },
    searchList() {},
    back() {
      history.back();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  position: relative;
}
// .inquiry-num {
// }
</style>